import { render, staticRenderFns } from "./agenda.vue?vue&type=template&id=9a15cb2c&"
import script from "./agenda.vue?vue&type=script&lang=js&"
export * from "./agenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports